import { Component, OnInit } from '@angular/core';
import { Partner } from '../../../partner/models/partner';
import { PartnerStateService } from '../../../partner/services/partner-state.service';
import { PartnerStateEnum } from '../../../partner/services/partner-state.enum';
import { KioskStateService } from '../../services/kiosk-state.service';
import { KioskStateEnum } from '../../services/kiosk-state.enum';

@Component({
  selector: 'app-kiosk-new-child',
  templateUrl: './kiosk-new-child.component.html',
  styleUrls: ['./kiosk-new-child.component.css']
})
export class KioskNewChildComponent implements OnInit {

  child: Partner;
  parent: Partner;

  actionInProgress: boolean;

  private _partnerFormIsValid: boolean;

  constructor(
    private partnerStateService: PartnerStateService,
    private kioskStateService: KioskStateService,
  ) {

  }

  ngOnInit() {
    this.child = new Partner();
    this.parent = new Partner();
  }

  get isSaveButtonEnabled(): boolean {
    return this._partnerFormIsValid && !this.actionInProgress && this.parent.waiver;
  }

  cancelClick() {
    this.kioskStateService.update(KioskStateEnum.ChildManagement);
  }

  saveClick() {
    this.actionInProgress = true;
    this.partnerStateService.createChild(this.child).subscribe(result => {
      if (result) {
        this.kioskStateService.update(KioskStateEnum.ChildManagement);
      }
      this.actionInProgress = false;
    });
  }

  onChildFormInvalid() {
    this._partnerFormIsValid = false;
  }

  onChildFormValid() {
    this._partnerFormIsValid = true;
  }

}
